module.exports = __webpack_public_path__ + "img/software_practicemaster.e135f9e1.jpg";